import React from 'react'
import { Checkbox, Form } from 'antd'
import { CheckboxGroupProps } from 'antd/lib/checkbox'
import { FormItemProps } from 'antd/lib/form/FormItem'
import { WrappedFieldProps } from 'redux-form'

const { Item } = Form

type ComponentProps = {
	disabled?: boolean
	placeholder: string
}

type Props = WrappedFieldProps & CheckboxGroupProps & FormItemProps & ComponentProps

const CheckboxField = (props: Props) => {
	const {
		input,
		label,
		required,
		meta: { error, touched },
		style,
		disabled,
		placeholder,
		className
	} = props

	return (
		<Item label={label} required={required} help={touched && error} validateStatus={error && touched ? 'error' : undefined} style={style}>
			<Checkbox className={className} checked={input.value} onChange={input.onChange} disabled={disabled}>
				{placeholder}
			</Checkbox>
		</Item>
	)
}

export default CheckboxField
